const activity = {
  activity: "نشاط", // translated 
  activities: "أنشطة", // translated 
  dates: "التاريخ", // translated 
  location: "موقع", // translated 
  languages: "اللغات", // translated 
  categories: "فئات", // translated 
  ticketOption: "خيار التذكرة", // translated 
  numberOfRatings: "عدد التقييمات", // translated 
  meetingPointInfo: "معلومات نقطة الالتقاء", // translated 
  meetingPoint: "نقطة إلتقاء", // translated 
  meetingPoints: "نقاط لقاء", // translated 
  providedBy: "المقدمة من", // translated 
  expirationDate: "تاريخ انتهاء الصلاحية", // translated 
  groupSize: "حجم المجموعة", // translated 
  features: "سمات", // translated 
  basedOn: "مرتكز على", // translated 
  reviewsFromVerCustomers: "مراجعات من العملاء الذين تم التحقق منهم", // translated 
  excellent: "ممتاز", // translated 
  great: "عظيم", // translated 
  average: "متوسط", // translated 
  poor: "فقير", // translated 
  bad: "سيء", // translated 
  onlyBookedCustomersTooltip:
    "يمكن فقط للعملاء الذين حجزوا هذا النشاط ترك تعليق", // translated 
  noReviewsYet: "في الوقت الحالي، لا توجد تعليقات لهذا النشاط.", // translated 
  backToActivitiesList: "العودة إلى قائمة الأنشطة", // translated 
  getPrices: "الحصول على الأسعار", // translated 
  availabilityAndPrices: "التوفر والأسعار", // translated 
  ticketOptions: "خيارات التذاكر", // translated 
  ticketInfo: "معلومات البطاقة", // translated 
  selectYourTickets: "حدد التذاكر الخاصة بك", // translated 
  product: "منتج", // translated 
  total: "المجموع", // translated 
  slot: "فتحة", // translated 
  language: "لغة", // translated 
  tickets: "التذاكر", // translated 
  ticketsFor: "تذاكر ل", // translated 
  previousStep: "خطوة سابقة", // translated 
  onlyAvailableInEnglish: "متوفر فقط باللغة الإنجليزية", // translated 
  guest: "ضيف", // translated 
  leadGuest: "الضيف الرئيسي", // translated 
  adult: "الكبار", // translated 
  child: "طفل", // translated 
  pleaseSelectAdult: "يرجى اختيار شخص بالغ واحد على الأقل", // translated 
  notAvailableActivity: "هذا المنتج غير متوفر", // translated 
  required: "مطلوب", // translated 
  pickupPoint: "نقطة الالتقاط", // translated 
  pickupPoints: "نقاط الالتقاط", // translated 
  ticketType: "نوع التذكرة", // translated 
  anonymous: "مجهول", // translated 
  printedVoucher: "تم قبول القسيمة المطبوعة", // translated 
  mobileVoucher: "تم قبول قسيمة الهاتف المحمول", // translated 
  mixedVoucher: "يتم قبول القسيمة المحمولة أو المطبوعة", // translated 
  safetyMeasures: "تم تطبيق تدابير السلامة", // translated 
  doThisBecause: "افعل هذا لأن", // translated 
  safetyInfo: "معلومات السلامة", // translated 
  reviewsHighestFirst: "عدد المراجعات (الأعلى أولاً)", // translated 
  bookingFee: "رسوم الحجز", // translated 
  startDate: "تاريخ البدء", // translated 
  endDate: "تاريخ الانتهاء", // translated 
  cancellationDeadlineAndFees: "الموعد النهائي للإلغاء والرسوم", // translated 
  resetTickets: "إعادة تعيين التذاكر", // translated 
  instantConfirmation: "تأكيد فوري", // translated 
  clickResetBtn: "انقر فوق زر إعادة الضبط للبدء مرة أخرى في اختيارك", // translated 
  whatToRemember: "ماذا تتذكر", // translated 
};



export default activity;
